export const getContainerStyle = (isMobile, pinsLength) => ({
  display: "flex",
  gap: isMobile ? 0.5 : 1.5,
  overflowX: "auto",
  WebkitOverflowScrolling: "touch",
  "&::-webkit-scrollbar": { display: "none" },
  msOverflowStyle: "none",
  scrollbarWidth: "none",
  alignItems: "center",
  mr: 1,
  width: "auto",
  minWidth: 0,
  maxWidth: isMobile
    ? (pinsLength > 2 ? "14rem" : "calc(100vw - 120px)")
    : (pinsLength > 2 ? "23.25rem" : "auto"),
});

export const getItemPaperStyle = (isMobile) => ({
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  padding: isMobile ? "0.25rem 0.375rem" : "0.375rem 0.75rem",
  borderRadius: "0.25rem",
  cursor: "pointer",
  transition: "all 0.2s",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    transform: "translateY(-0.0625rem)",
  },
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  minWidth: isMobile ? "6.875rem" : "11.25rem",
  maxWidth: isMobile ? "8.125rem" : "13.75rem",
  height: isMobile ? "2.625rem" : "3.25rem",
  flexShrink: 0,
});

export const getItemRowStyle = () => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
});

export const getDisplayNameStyle = (isMobile) => ({
  fontWeight: "bold",
  fontSize: isMobile ? "0.75rem" : "0.875rem",
  color: "white",
  lineHeight: 1.2,
  mb: 0.25,
});

export const getLtpStyle = (isMobile) => ({
  color: "white",
  fontSize: isMobile ? "0.7rem" : "0.8rem",
  lineHeight: 1.2,
});

export const getChangeColumnStyle = (selectedClass) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  color:
    selectedClass === "buy"
      ? "#00E676"
      : selectedClass === "sell"
        ? "#FF1744"
        : "white",
});

export const getAbsoluteChangeStyle = (isMobile) => ({
  fontWeight: "bold",
  fontSize: isMobile ? "0.65rem" : "0.75rem",
  whiteSpace: "nowrap",
});

export const getPercentChangeStyle = (isMobile) => ({
  fontSize: isMobile ? "0.6rem" : "0.7rem",
  whiteSpace: "nowrap",
});
